import { render, staticRenderFns } from "./property-matched.vue?vue&type=template&id=0b410a47&"
import script from "./property-matched.vue?vue&type=script&lang=js&"
export * from "./property-matched.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports